<template>
  <div class="sc-supplier">
    <div class="inner">
      <div class="title">
        <div class="left">
          <img class="icon" src="@/assets/圆圈.png" alt />
          <div class="name">供应商数据</div>
        </div>
        <div class="right">
          <ScYearMonthPicker v-if="date" :date="date" @change="onMonthChange" />
        </div>
      </div>

      <div class="charts">
        <div class="title">供应商供货量占比</div>
        <div v-if="top5.length > 0">
          <div class="left">
            <v-chart :options="pieOption" />
          </div>
          <div class="right">
            <div
              v-for="(item, index) in top5"
              :key="index"
              :class="index % 2 ? 'item' : 'item dott'"
            >
              <div class="rate">
                {{ util.formatMoney(item.rate * 100, 2, '') }}%
              </div>
              <div class="desc">
                  <!--更多供应商为1个时不显示更多供应商（即供应商总数为5个） 直接显示实际的供应商-->
                <div v-if="top5.length > 5 || moreSupplier.length === 1 ? true : index < 4" class="head">
                  {{ item.supplierName
                  }}{{ item.supplierCode ? ' / ' + item.supplierCode : '' }}
                </div>
                <div v-if="top5.length > 5 || moreSupplier.length === 1? false : index === 4" class="head" >
                  {{ item.supplierName }}（合计共{{ item.count }}个）
                  <span class="more" @click="handleGetMoreSupplier">
                    查看更多>>
                  </span>
                </div>
                <div class="cont">
                  <el-row>
                    <el-col :span="8"
                      >供货量：{{ util.formatMoney(item.quantity, 2, '')
                      }}{{ item.unit }}</el-col
                    >
                    <el-col :span="8"
                      >进货额：{{
                        util.formatMoney(item.amount, 2, '￥')
                      }}</el-col
                    >
                    <el-col :span="8"
                      >移动平均价：{{
                        util.formatMoney(item.amount / item.quantity, 2, '￥')
                      }}</el-col
                    >
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </div>
        <NoData title="该商品查询月暂无供货数据" v-else />

        <div class="bottom">
          <el-select
            v-model="supplierCode"
            placeholder="请选择"
            class="supplier-select"
            @change="onSupplierChange"
            filterable
          >
            <el-option
              v-for="item in supplierOptions"
              :key="item.value"
              :label="item.value === allSupplierCode?item.label: item.label + ' / ' + item.value"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="provinceCode"
            placeholder="请选择"
            class="province-select"
            @change="onProvinceChange"
          >
            <el-option
              v-for="item in provinceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-tooltip content="当供应商选择全部供应商且省区选择某地区时，为该地区所有供货供应商供货量的总和" placement="top-start">
            <i class="el-icon-question icon"></i>
          </el-tooltip>
          <div class="menu">
            <div
              :class="isQuantity ? 'item active' : 'item'"
              @click="isQuantity = true"
            >
              供货量
            </div>
            <div
              :class="isQuantity ? 'item' : 'item active'"
              @click="isQuantity = false"
            >
              进货额
            </div>
          </div>
          <v-chart
            :options="barOption1"
            v-if="isQuantity"
            style="height: 400px"
          />
          <v-chart :options="barOption2" v-else style="height: 400px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from './NoData'
import ScYearMonthPicker from './ScYearMonthPicker'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import echarts from 'echarts'

import util from '@/plugins/util'

let unit = ''
const ALL_SUPPLIER_CODE = '999999999'
export default {
  name: 'ScSupplier',
  components: {
    ScYearMonthPicker,
    NoData,
    'v-chart': ECharts
  },
  props: {
    code: {
      type: String,
      required: true
    },
    categoryCode:{
        type: String,
        required: true
    }
  },
  data() {
    return {
      allSupplierCode:ALL_SUPPLIER_CODE,
      date: false,
      isQuantity: true,
      allResults: [],
      provinceResults: [],
      latestDate: '',
      latestYearMonth: '',
      top5: [],
      moreSupplier: [], // 更多供应商
      supplierOptions: [],
      supplierCode: '',
      provinceOptions: [],
      provinceCode: '000000',
      pieOption: {
        // visualMap: {
        //   type: "piecewise",
        //   show: false,
        //   inRange: {
        //     color: ["#019073", "#0DBF9B", "#25E8C1", "#9DF2E1", "#E1F2EE"]
        //   }
        // },
        tooltip: {
          trigger: 'item'
          // backgroundColor: "#FFFFFF",
          // padding: 15,
          // textStyle: {
          //   color: "#999999",
          //   fontSize: 12,
          //   lineHeight: 20
          // },
          // extraCssText: "box-shadow:0px -1px 9px 0px rgba(68,70,86,0.2);",
          // // formatter: "{a}<br />{b}<br />{c}<br />{d}",
          // formatter:
          //   "<div style='color: #333; height: 25px;'>{b}</div>" +
          //   "<div style='color: #1B994F;'>供货量：</div>" +
          //   "<div style='color: #1B994F; height: 30px; line-height: 30px; font-size: 20px'>{c}KG</div>" +
          //   "<div style='color: #999'>占比：<span style='color: #444;'>{d}%</span></div>"
        },
        series: [
          {
            name: '供应商供货量占比',
            type: 'pie',
            radius: '100',
            center: ['50%', '50%'],
            data: [],
            clockwise: false,
            label: {
              formatter: '{b}：{d}%',
              lineHeight: 16,
              textStyle: {
                color: 'rgba(51, 51, 51, 1)'
              }
            },
            labelLine: {
              lineStyle: {
                color: 'rgba(1, 144, 115, 1)'
              },
              length: 10,
              length2: 20
            }
          }
        ]
      },
      barOption1: {
        grid: {
          top: 60,
          bottom: 60,
          right: 100,
          left: 100,
          containLabel: false,
          borderWidth: 0,
          borderColor: '#eee'
        },
        legend: {
          data: ['本年供货量', '去年供货量', '同比增长率'],
          x: 'right'
        },
        xAxis: {
          type: 'category',
          data: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
          ],
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.25)'
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            color: '#848791'
          }
        },
        yAxis: [
          {
            type: 'value',
            show: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.09)',
                type: 'dashed'
              }
            },
            axisLabel: {
              color: '#595959',
              formatter: function(val) {
                return util.formatMoney(val, 2, '') + unit
              }
            }
          },
          {
            type: 'value',
            show: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.09)',
                type: 'dashed'
              }
            },
            axisLabel: {
              color: '#595959',
              formatter: function(val) {
                return util.formatMoney(val, 2, '') + '%'
              }
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            lineStyle: {
              color: '#01B484'
            }
          },
          position: function(point, params, dom, rect, size) {
            return [point[0] + 60, '10%']
          },
          backgroundColor: '#fff',
          padding: 15,
          textStyle: {
            color: '#999',
            fontSize: 12,
            fontFamily: 'DIN Medium',
            lineHeight: 20
          },
          extraCssText: 'box-shadow: 0px -1px 9px 0px rgba(68, 70, 86, 0.2);',
          formatter: function(params) {
            const thisYear = params[0].data.item
            const lastYear = params[1].data.item
            const rate = params[2].data.value

            // console.log(thisYear);

            let sb = ''
            if (thisYear) {
              sb +=
                `<div style='color: #1B994F;'>${thisYear.month}月供货量：</div>` +
                `<div style='color: #1B994F; height: 30px; line-height: 20px; font-size: 20px'>${util.formatMoney(
                  thisYear.quantity,
                  2,
                  ''
                )}${unit}</div>` +
                `<div style='color: #999999;'>${
                  thisYear.month
                }月供货量占比：<span style='color: #333333;'>${util.formatMoney(
                  thisYear.rate * 100,
                  2,
                  ''
                )}%</span></div>`
            }
            if (lastYear) {
              sb +=
                `<div style='color: #999999; margin-top: 15px'>去年${lastYear.month}月供货量：</div>` +
                `<div style='color: #333333; height: 30px; line-height: 20px; font-size: 20px'>${util.formatMoney(
                  lastYear.quantity,
                  2,
                  ''
                )}${unit}</div>` +
                `<div style='color: #999999;'>去年${
                  lastYear.month
                }月供货量占比：<span style='color: #333333;'>${util.formatMoney(
                  lastYear.rate * 100,
                  2,
                  ''
                )}%</span></div>`
            }
            if (rate) {
              sb += `<div style='color: #999; margin-top: 15px'>同比增长：<span style='color: rgba(242, 131, 9, 1); font-weight: bold;'>${util.formatMoney(
                rate,
                2,
                ''
              )}%</span></div>`
            }
            return sb
          }
        },

        series: [
          {
            name: '本年供货量',
            data: [],
            type: 'bar',
            barGap: 0,
            barWidth: 20,
            itemStyle: {
              normal: {
                width: 20,
                color: 'rgba(1, 180, 132, 1)'
              }
            }
          },
          {
            name: '去年供货量',
            data: [],
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              normal: {
                width: 20,
                color: 'rgba(160, 225, 208, 1)'
              }
            }
          },
          {
            name: '同比增长率',
            data: [],
            type: 'line',
            symbol: 'circle',
            symbolSize: 6,
            emphasis: {
              itemStyle: {
                borderWidth: 4
              }
            },
            yAxisIndex: 1,
            smooth: true,
            lineStyle: {
              color: 'rgba(242, 131, 9, 1)'
            },
            itemStyle: {
              color: 'rgba(242, 131, 9, 1)',
              borderWidth: 2,
              borderColor: '#fff'
            }
          }
        ]
      },
      barOption2: {
        grid: {
          top: 60,
          bottom: 60,
          right: 100,
          left: 100,
          containLabel: false,
          borderWidth: 0,
          borderColor: '#eee'
        },
        legend: {
          data: ['本年进货额', '去年进货额', '同比增长率'],
          x: 'right'
        },
        xAxis: {
          type: 'category',
          data: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
          ],
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.25)'
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            color: '#848791'
          }
        },
        yAxis: [
          {
            type: 'value',
            show: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.09)',
                type: 'dashed'
              }
            },
            axisLabel: {
              color: '#595959',
              formatter: function(val) {
                return util.formatMoney(val, 2, '￥')
              }
            }
          },
          {
            type: 'value',
            show: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.09)',
                type: 'dashed'
              }
            },
            axisLabel: {
              color: '#595959',
              formatter: function(val) {
                return util.formatMoney(val, 2, '') + '%'
              }
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            lineStyle: {
              color: '#01B484'
            }
          },
          position: function(point, params, dom, rect, size) {
            return [point[0] + 20, '10%']
          },
          backgroundColor: '#fff',
          padding: 15,
          textStyle: {
            color: '#999',
            fontSize: 12,
            fontFamily: 'DIN Medium',
            lineHeight: 20
          },
          extraCssText: 'box-shadow: 0px -1px 9px 0px rgba(68, 70, 86, 0.2);',
          formatter: function(params) {
            const thisYear = params[0].data.item
            const lastYear = params[1].data.item
            const rate = params[2].data.value

            let sb = ''

            // console.log(thisYear, lastYear);
            if (thisYear) {
              sb +=
                `<div style='color: #1B994F;'>${thisYear.month}月进货额：</div>` +
                `<div style='color: #1B994F; height: 30px; line-height: 20px; font-size: 20px'>${util.formatMoney(
                  thisYear.amount,
                  2,
                  ''
                )}元</div>` +
                `<div style='color: #999999;'>${
                  thisYear.month
                }月进货额占比：<span style='color: #333333;'>${util.formatMoney(
                  thisYear.rate * 100,
                  2,
                  ''
                )}%</span></div>`
            }
            if (lastYear) {
              sb +=
                `<div style='color: #999999; margin-top: 15px'>去年${lastYear.month}月进货额：</div>` +
                `<div style='color: #333333; height: 30px; line-height: 20px; font-size: 20px'>${util.formatMoney(
                  lastYear.amount,
                  2,
                  ''
                )}元</div>` +
                `<div style='color: #999999;'>去年${
                  lastYear.month
                }月进货额占比：<span style='color: #333333;'>${util.formatMoney(
                  lastYear.rate * 100,
                  2,
                  ''
                )}%</span></div>`
            }
            if (rate) {
              sb += `<div style='color: #999; margin-top: 15px'>同比增长：<span style='color: rgba(242, 131, 9, 1); font-weight: bold;'>${util.formatMoney(
                rate,
                2,
                ''
              )}%</span></div>`
            }
            return sb
          }
        },

        series: [
          {
            name: '本年进货额',
            data: [],
            type: 'bar',
            barGap: 0,
            barWidth: 20,
            itemStyle: {
              normal: {
                width: 20,
                color: 'rgba(1, 180, 132, 1)'
              }
            }
          },
          {
            name: '去年进货额',
            data: [],
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              normal: {
                color: 'rgba(160, 225, 208, 1)'
              }
            }
          },
          {
            name: '同比增长率',
            data: [],
            type: 'line',
            symbol: 'circle',
            symbolSize: 6,
            emphasis: {
              itemStyle: {
                borderWidth: 4
              }
            },
            yAxisIndex: 1,
            smooth: true,
            lineStyle: {
              color: 'rgba(242, 131, 9, 1)'
            },
            itemStyle: {
              color: 'rgba(242, 131, 9, 1)',
              borderWidth: 2,
              borderColor: '#ffffff'
            }
          }
        ]
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.queryAll().then(() => {
        this.calcLatestDate()
        this.drawPie()
        this.calcSupplierOptions()
        this.drawBar1()
        this.drawBar2()
      })

      this.queryProvince().then(() => {
        this.calcProvinceOptions()
      })
    },
    async queryAll() {
      const response = await this.ajax.doPost({
        packageName: 'sc',
        className: 'scSupplierAllMonth',
        methodName: 'query',
        params: {
          code: this.code,
          categoryCode:this.categoryCode
        }
      })
      this.allResults = response.map((e) => {
        const year = parseInt(e.yearMonth.substring(0, 4))
        const month = parseInt(e.yearMonth.substring(4, 6))
        return {
          ...e,
          provinceCode: '000000',
          year: year,
          month: month,
          date: new Date(year, month - 1)
        }
      })
    },
    async queryProvince() {
      const response = await this.ajax.doPost({
        packageName: 'sc',
        className: 'scSupplierProvinceMonth',
        methodName: 'query',
        params: {
          code: this.code,
          categoryCode:this.categoryCode
        }
      })
      this.provinceResults = response.map((e) => {
        const year = parseInt(e.yearMonth.substring(0, 4))
        const month = parseInt(e.yearMonth.substring(4, 6))
        return {
          ...e,
          year: year,
          month: month,
          date: new Date(year, month - 1)
        }
      })
    },
    /**
     * 获取更多供应商
     * @author Ren YuLei 2020/10/15
     */
    handleGetMoreSupplier (){
        const { top5, moreSupplier } =this
        this.top5 = top5.slice(0, 4).concat(moreSupplier)
    },
    drawPie() {
      const data = this.allResults
        .filter((e) => e.yearMonth === this.latestYearMonth)
        .filter((e) => e.quantity > 0)
        .sort((a, b) => b.quantity - a.quantity)

      if (data.length > 0) {
        const total = data
          .map((e) => e.quantity)
          .reduce((acc, cur) => acc + cur)

        const top4 = data.slice(0, 4).map((e) => {
          return {
            ...e,
            rate: e.quantity / total
          }
        })
        if (data.length > 4) {
          const last = data.slice(4, data.length).reduce((a, b) => {
            const quantity = a.quantity + b.quantity
            const amount = a.amount + b.amount
            return {
              supplierName: '其他供应商',
              quantity,
              amount,
              unit: a.unit,
              rate: quantity / total,
              count: data.length - 4
            }
          })

            this.top5 = data.length === 5 ? data.map(e=>({...e, rate: e.quantity / total})) : top4.concat(last)
          this.moreSupplier = data.slice(4, data.length).map((e) => {
              return {
                  ...e,
                  rate: e.quantity / total
              }
          })
        } else {
          this.top5 = top4
        }

        const colors = ['#019073', '#0DBF9B', '#25E8C1', '#9DF2E1', '#E1F2EE']

        // this.pieOption.visualMap.min = 0;
        // this.pieOption.visualMap.max = this.top5[0].quantity;

        this.pieOption.series[0].data = this.top5.map((e, i) => {
          let name = e.supplierName

          if (e.supplierName.length > 10) {
            name =
              e.supplierName.substring(0, 10) +
              '\n' +
              e.supplierName.substring(10)
          }
          return {
            name: name,
            value: e.quantity,
            itemStyle: {
              color: colors[i]
            },
            label: {
              show: i === 0
            },
            labelLine: {
              show: i === 0,
              length: 30,
              length2: 10,
              lineStyle: {
                color: colors[i]
              }
            },
            emphasis: {
              label: {
                show: true
              },
              labelLine: {
                show: true,
                length: 30,
                length2: 10,
                lineStyle: {
                  color: colors[i]
                }
              }
            },
            tooltip: {
              backgroundColor: '#fff',
              padding: 15,
              textStyle: {
                color: '#999',
                fontSize: 12,
                lineHeight: 20
              },
              extraCssText:
                'box-shadow: 0px -1px 9px 0px rgba(68, 70, 86, 0.2);',
              formatter:
                `<div style='color: #333; height: 25px;'>${e.supplierName}</div>` +
                "<div style='color: #1B994F;'>供货量：</div>" +
                `<div style='color: #1B994F; height: 30px; line-height: 30px; font-size: 20px'>${this.util.formatMoney(
                  e.quantity,
                  2,
                  ''
                )}${e.unit}</div>` +
                "<div style='color: #999'>占比：<span style='color: #444;'>{d}%</span></div>"
            }
          }
        })

        // this.supplierCode = this.top5[0].supplierCode
        this.supplierCode = ALL_SUPPLIER_CODE
      } else {
        this.top5 = []
      }
    },
    drawBar1() {
      const data =
        this.provinceCode === '000000' ? this.allResults : this.provinceResults

      const listBefore = data
        .filter((e) => e.quantity > 0)
        .filter((e) => e.provinceCode === this.provinceCode)

      const list =
        this.supplierCode === ALL_SUPPLIER_CODE
          ? listBefore
          : listBefore.filter((e) => e.supplierCode === this.supplierCode)

      // const list = data
      //   .filter(e => e.quantity > 0)
      //   .filter(e => e.supplierCode === this.supplierCode)
      //   .filter(e => e.provinceCode === this.provinceCode);

      const monthArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

      this.barOption1.series[0].data = monthArray.map((month) => {
        const monthData = list.filter(
          (e) => e.year === this.latestDate.getFullYear() && e.month == month
        )

        const total = data
          .filter((e) => e.quantity > 0)
          .filter((e) => e.provinceCode === this.provinceCode)
          .filter(
            (e) => e.year === this.latestDate.getFullYear() && e.month == month
          )
          .map((e) => e.quantity)
          .reduce((a, b) => a + b, 0)

        if (monthData.length) {
          const value = monthData.reduce((a, b) => a + b.quantity, 0)
          return {
            value,
            item: {
              ...monthData[0],
              quantity: value,
              rate: total ? value / total : 0
            }
          }
        } else {
          return {}
        }
      })

      this.barOption1.series[1].data = monthArray.map((month) => {
        const monthData = list.filter(
          (e) =>
            e.year === this.latestDate.getFullYear() - 1 && e.month === month
        )

        const total = data
          .filter((e) => e.quantity > 0)
          .filter((e) => e.provinceCode === this.provinceCode)
          .filter(
            (e) =>
              e.year === this.latestDate.getFullYear() - 1 && e.month === month
          )
          .map((e) => e.quantity)
          .reduce((a, b) => a + b, 0)

        if (monthData.length) {
          const value = monthData.reduce((a, b) => a + b.quantity, 0)
          return {
            value,
            item: {
              ...monthData[0],
              quantity: value,
              rate: total ? value / total : 0
            }
          }
        } else {
          return {}
        }
      })

      this.barOption1.series[2].data = monthArray.map((month) => {
        const e1 = list.filter(
          (e) => e.year === this.latestDate.getFullYear() && e.month == month
        )

        const e2 = list.filter(
          (e) =>
            e.year === this.latestDate.getFullYear() - 1 && e.month == month
        )

        if (e1.length && e2.length) {
          const v1 = e1.reduce((a, b) => a + b.quantity, 0)
          const v2 = e1.reduce((a, b) => a + b.quantity, 0)
          return {
            value: ((v1 - v2) / v2) * 100
          }
        } else {
          return {}
        }
      })
    },
    drawBar2() {
      const data =
        this.provinceCode === '000000' ? this.allResults : this.provinceResults

      const listBefore = data
        .filter((e) => e.amount > 0)
        .filter((e) => e.provinceCode === this.provinceCode)

      const list =
        this.supplierCode === ALL_SUPPLIER_CODE
          ? listBefore
          : listBefore.filter((e) => e.supplierCode === this.supplierCode)
      // const list = data
      //   .filter(e => e.amount > 0)
      //   .filter(e => e.supplierCode === this.supplierCode)
      //   .filter(e => e.provinceCode === this.provinceCode);

      const monthArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

      this.barOption2.series[0].data = monthArray.map((month) => {
        const monthData = list.filter(
          (e) => e.year === this.latestDate.getFullYear() && e.month == month
        )

        const total = data
          .filter((e) => e.amount > 0)
          .filter((e) => e.provinceCode === this.provinceCode)
          .filter(
            (e) => e.year === this.latestDate.getFullYear() && e.month == month
          )
          .map((e) => e.amount)
          .reduce((a, b) => a + b, 0)

        if (monthData.length) {
          const value = monthData.reduce((a, b) => a + b.amount, 0)

          return {
            value,
            item: {
              ...monthData[0],
              amount: value,
              rate: total ? value / total : 0
              // rate: total ? e.amount / total : 0
            }
          }
        } else {
          return {}
        }
      })

      this.barOption2.series[1].data = monthArray.map((month) => {
        const monthData = list.filter(
          (e) =>
            e.year === this.latestDate.getFullYear() - 1 && e.month == month
        )

        const total = data
          .filter((e) => e.amount > 0)
          .filter((e) => e.provinceCode === this.provinceCode)
          .filter(
            (e) =>
              e.year === this.latestDate.getFullYear() - 1 && e.month == month
          )
          .map((e) => e.amount)
          .reduce((a, b) => a + b, 0)

        if (monthData.length) {
          const value = monthData.reduce((a, b) => a + b.amount, 0)
          return {
            value,
            item: {
              ...monthData[0],
              amount: value,
              rate: total ? value / total : 0
            }
          }
        } else {
          return {}
        }
      })

      this.barOption2.series[2].data = monthArray.map((month) => {
        const e1 = list.filter(
          (e) => e.year === this.latestDate.getFullYear() && e.month == month
        )

        const e2 = list.filter(
          (e) =>
            e.year === this.latestDate.getFullYear() - 1 && e.month == month
        )

        if (e1.length && e2.length) {
          const v1 = e1.reduce((a, b) => a + b.amount, 0)
          const v2 = e1.reduce((a, b) => a + b.amount, 0)
          return {
            value: ((v1 - v2) / v2) * 100
          }
        } else {
          return {}
        }
      })
    },
    onMonthChange(e) {
      const yearMonth =
        e.getFullYear() + (e.getMonth() + 1).toString().padStart(2, '0')

      this.latestYearMonth = yearMonth
      this.drawPie()
    },
    onSupplierChange() {
      this.calcProvinceOptions()

      this.drawBar1()
      this.drawBar2()
    },
    onProvinceChange() {
      this.drawBar1()
      this.drawBar2()
    },
    onBarChange() {},
    // 计算最新日期
    calcLatestDate() {
      const data = this.allResults.sort(
        (a, b) => b.date.getTime() - a.date.getTime()
      )

      this.latestDate = data[0].date
      this.latestYearMonth = data[0].yearMonth

      this.date = data[0].date
      unit = data[0].unit
    },
    // 计算供应商选项
    calcSupplierOptions() {
      const data =
        this.provinceCode === '000000' ? this.allResults : this.provinceResults

      this.supplierOptions = this.util
        .groupBy(data, (e) => e.supplierCode)
        .map((e) => {
          return {
            label: e[0].supplierName,
            value: e[0].supplierCode
          }
        })
        .sort((a, b) => {
          return a.label.localeCompare(b.label)
        })

        this.supplierOptions.unshift({
          label: '全部供应商',
          value: ALL_SUPPLIER_CODE
        })
    },
    // 计算省份选项
    calcProvinceOptions() {
      this.provinceCode = '000000'
      this.provinceOptions = this.util
        .groupBy(
          this.provinceResults.filter(
            (e) => e.supplierCode === this.supplierCode ||  this.supplierCode === ALL_SUPPLIER_CODE
          ),
          (e) => e.provinceCode
        )
        .map((e) => {
          return {
            label: e[0].provinceName,
            value: e[0].provinceCode
          }
        })
        .concat({
          label: '全国',
          value: '000000'
        })
        .sort((a, b) => {
          return a.value.localeCompare(b.value)
        })
    }
  }
}
</script>

<style lang="scss">
.sc-supplier {
  width: 100%;

  .inner {
    width: 1100px;
    margin: 0 auto;

    .chart {
      width: 100%;
      height: 400px;
    }

    .echarts {
      width: 100%;
      height: 100%;
    }

    .title {
      margin: 20px 0 10px 0;
      height: 40px;

      .left {
        float: left;

        img.icon {
          display: inline-block;
          width: 12px;
          height: 12px;

          margin-right: 10px;
        }

        div.name {
          display: inline-block;

          height: 28px;
          font-size: 20px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 28px;
        }
      }
      .right {
        float: right;
      }
    }

    .supplier-select {
      margin-right: 10px;
      .el-input__inner {
        width: 330px;
      }
    }

    .province-select {
      margin-right: 20px;
      .el-input__inner {
        width: 130px;
      }
    }
    .icon {
     font-size: 20px;
      margin: 0 20px 0 -10px;
      color: #1b994f;
      cursor: pointer;
    }
    .menu {
      width: 130px;
      display: inline-block;
      // margin: 15px auto;
      //   position: absolute;
      top: -5px;
      z-index: 1000;
      .item {
        width: 60px;
        height: 28px;
        display: inline-block;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(51, 51, 51, 1);
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        cursor: pointer;
      }
      .active {
        color: white;
        background: rgba(51, 51, 51, 1);
      }
    }

    .charts {
      border-top: 1px solid #f4f4f4;
      //   padding-top: 30px;
      .title {
        height: 22px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
        text-align: center;
        margin-bottom: 20px;
      }
      .left {
        display: inline-block;

        width: 520px;
        height: 380px;

        margin-right: 30px;
      }
      .right {
        display: inline-block;

        width: 520px;
        height: 420px;

        margin-left: 30px;
        max-height: 420px;
        overflow-y: auto;
        overflow-x: hidden;
        vertical-align: top;

        .item {
          width: 520px;
          height: 80px;

          .rate {
            display: inline-block;
            width: 80px;
            font-size: 16px;
            font-weight: bold;
            font-family: 'DIN Medium';
            color: rgba(27, 153, 79, 1);
            height: 80px;
            line-height: 80px;
            text-align: center;
            vertical-align: top;
          }
          .more{
            color: rgba(27, 153, 79, 1);
            font-size: 14px;
            cursor: pointer;
          }
          .desc {
            display: inline-block;
            width: 440px;
            vertical-align: top;
            height: 60px;
            margin: 10px 0;
            .head {
              font-size: 16px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);

              height: 30px;
              line-height: 30px;
            }
            .cont {
              font-size: 12px;
              font-weight: 400;
              color: rgba(132, 135, 145, 1);
              height: 30px;
              line-height: 30px;
            }
          }
        }

        .dott {
          background: rgba(244, 249, 248, 1);
        }
      }
    }
  }
}
</style>
